module.exports = __webpack_public_path__ + "img/icon_theme.482c8fdd.svg";